import { Tag } from '@ds';
import { memo } from 'react';
import { useFormatDate } from 'src/utils/hooks/useFormatDate';
import { TagSize, TagVariant } from '@ds/elements/Tag/Tag.types';
import styles from './QuestionnaireCard.module.scss';
import classNames from 'classnames';

export enum QuestionnaireStatus {
  NotStarted = 'Not Started',
  Completed = 'Completed',
  InProgress = 'Started, Incomplete',
}

const STATUS_CLASS = {
  [QuestionnaireStatus.NotStarted]: TagVariant.Error,
  [QuestionnaireStatus.Completed]: TagVariant.Success,
  [QuestionnaireStatus.InProgress]: TagVariant.Error,
};

interface IQuestionnaireCard {
  name: string;
  relationships: string[];
  status: QuestionnaireStatus;
  completedDate: string;
  outline?: boolean;
  onClick: () => void;
}

const QuestionnaireCard = memo(
  ({ name, relationships, status, completedDate, outline = true, onClick }: IQuestionnaireCard) => {
    const formattedCompletedDate = useFormatDate(completedDate);

    return (
      <div className={classNames(styles['questionnaire-card'], { [styles['questionnaire-card-outline']]: outline })}>
        <div>
          <div className={styles['questionnaire-title-dependant']} onClick={onClick}>
            <p className={styles['card-title']}>{name}</p>
            {relationships.length > 0 && (
              <p className={styles['questionnaire-dependant']}>({relationships.join(', ')})</p>
            )}
          </div>
          <Tag variant={STATUS_CLASS[status]} size={TagSize.Large} className={styles['questionnaire-tag']}>
            {status}
            {status === QuestionnaireStatus.Completed && <> {`on ${formattedCompletedDate}`}</>}
          </Tag>
        </div>
      </div>
    );
  }
);

export default QuestionnaireCard;
